import React, { useCallback, useEffect, useState } from 'react';

import classnames from 'classnames';
import { FaBars, FaTimes } from 'react-icons/fa';
import Header from './Header';
import Nav from './Nav';
import KPIs from './KPIs';
import Footer from './Footer';
import GameList from './GameList';
import Calendar from './Calendar';
import TeamFilter from './TeamFilter';
import qDocPromise from '../js/qDoc';

const styles = require('./Current-styles.css');

const Current = () => {
  const [qDoc, setQDoc] = useState(null);
  const [qObj, setQObj] = useState(null);
  const [data, setData] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpenClick = useCallback(() => {
    setIsSidebarOpen(true);
  });
  const handleCloseClick = useCallback(() => {
    setIsSidebarOpen(false);
  });
  useEffect(() => {
    (async () => {
      try {
        const _qDoc = await qDocPromise;
        setQDoc(_qDoc);
        const _qObj = await _qDoc.createSessionObject({
          qInfo: { qType: 'data' },
          qTreeDataDef: {
            qDimensions: [
              {
                qDef: {
                  qFieldDefs: ["=If(d_DateYear = '$(vYear)', Date(Floor(d_Date), 'WWWW') & ' /// ' & Date(Floor(d_Date), 'DD MMMM'))"],
                  qSortCriterias: [{
                    qSortByExpression: 1,
                    qExpression: 'Max(Floor(num(d_Date)))',
                  }],
                },
                qNullSuppression: true,
                qAttributeDimensions: [
                  {
                    qDef: "=Date(Floor(d_Date), 'YYYY-MM-DD')",
                    qAttribute: true,
                  },
                ],
              },
              {
                qDef: { qFieldDefs: ['n_MatchID'] },
                qAttributeDimensions: [
                  {
                    qDef: "=Date(d_Date, 'hh:mm')",
                    qAttribute: true,
                  },
                  {
                    qDef: "=c_Stadium & ', ' & c_City",
                    qAttribute: true,
                  },
                  {
                    qDef: '=If(isNull(c_Phase2), c_Phase1, c_Phase2)',
                    qAttribute: true,
                  },
                  {
                    qDef: "=c_Team1 & ' V ' & c_Team2",
                    qAttribute: true,
                  },
                  {
                    qDef: 'c_Team1',
                    qAttribute: true,
                  },
                  {
                    qDef: 'c_Team2',
                    qAttribute: true,
                  },
                  {
                    qDef: "=SubField(c_LiveScore, '-', 1)",
                    qAttribute: true,
                  },
                  {
                    qDef: "=SubField(SubField(c_LiveScore, '-', 2), '(', 1)",
                    qAttribute: true,
                  },
                  {
                    qDef: 'MatchStatusCode',
                    qAttribute: true,
                  },
                ],
              },
              {
                qDef: {
                  qFieldDefs: ["=If(c_ActionSet = 'Goal' OR c_ActionSet = 'Official Warning', n_MatchActionID)"],
                  qSortCriterias: [{
                    qSortByExpression: 1,
                    qExpression: 'only(n_TimeSort)',
                  }],
                },
                // qNullSuppression: true,
                qAttributeDimensions: [
                  {
                    qDef: 'c_Team',
                    qAttribute: true,
                  },
                  {
                    qDef: 'c_Action',
                    qAttribute: true,
                  },
                  {
                    qDef: "=c_Person & ' (' & Ceil(n_TimeSort / 60000) & ' MIN)'",
                    qAttribute: true,
                  },
                ],
              },
            ],
            qOpenFullyExpanded: true,
          },
        });
        setQObj(_qObj);
        _qObj.on('changed', async () => {
          setData(await _qObj.getHyperCubeTreeData('/qTreeDataDef'));
        });
        setData(await _qObj.getHyperCubeTreeData('/qTreeDataDef'));
      } catch (error) {
        console.log(error); //eslint-disable-line
      }
    })();
  }, []);
  useEffect(() => () => {
    if (qDoc) qDoc.clearAll();
    if (qObj) qDoc.destroySessionObject(qObj.id);
  }, [qObj]);
  return (
    <>
      <Header />
      <Nav />
      <KPIs />
      <div className={styles.layout}>
        {!isSidebarOpen && (
          <button type="button" className={styles.openButton} onClick={handleOpenClick}>
            <FaBars />
          </button>
        )}
        {isSidebarOpen && (
          <button type="button" className={styles.closeButton} onClick={handleCloseClick}>
            <FaTimes />
          </button>
        )}
        <div className={classnames(styles.sidebar, isSidebarOpen && styles.sidebarOpen)}>
          <div className={styles.sidebarContent}>
            <Calendar data={data} />
            <TeamFilter />
          </div>
        </div>
        <div className={styles.content}>
          <GameList data={data} />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Current;
